export type HmiSvgAssetSeed = {
  id: string;
  kind: "svg";
  title: string;
  source: "curated";
  viewBox: string;
  content: string;
};

export const builtinHmiSvgAssets: HmiSvgAssetSeed[] = [
  {
    id: "2b8c97ef-c9c2-4a34-97dc-55bc04f1da11",
    kind: "svg",
    title: "Cooling Coil",
    source: "curated",
    viewBox: "0 0 240 140",
    content:
      '<svg viewBox="0 0 240 140" xmlns="http://www.w3.org/2000/svg"><rect x="14" y="18" width="212" height="104" rx="18" fill="#f6fbf8" stroke="#315d4c" stroke-width="6"/><path d="M48 38h24c12 0 22 10 22 22v20c0 12-10 22-22 22H48" fill="none" stroke="#1f7a4a" stroke-width="8" stroke-linecap="round"/><path d="M110 38h24c12 0 22 10 22 22v20c0 12-10 22-22 22h-24" fill="none" stroke="#1f7a4a" stroke-width="8" stroke-linecap="round"/><path d="M172 38h20c12 0 20 10 20 22v20c0 12-8 22-20 22h-20" fill="none" stroke="#1f7a4a" stroke-width="8" stroke-linecap="round"/></svg>',
  },
  {
    id: "50ff5daf-4cb6-489d-8430-db68cd20e959",
    kind: "svg",
    title: "Sensor Cluster",
    source: "curated",
    viewBox: "0 0 220 180",
    content:
      '<svg viewBox="0 0 220 180" xmlns="http://www.w3.org/2000/svg"><rect x="26" y="30" width="168" height="120" rx="22" fill="#fbfdfc" stroke="#335846" stroke-width="6"/><circle cx="74" cy="72" r="18" fill="#93d3a8" stroke="#2e5b49" stroke-width="5"/><circle cx="146" cy="72" r="18" fill="#c8ddd1" stroke="#2e5b49" stroke-width="5"/><circle cx="74" cy="112" r="18" fill="#c8ddd1" stroke="#2e5b49" stroke-width="5"/><circle cx="146" cy="112" r="18" fill="#93d3a8" stroke="#2e5b49" stroke-width="5"/><path d="M56 18h32M132 18h32M110 150v20" stroke="#2e5b49" stroke-width="8" stroke-linecap="round"/></svg>',
  },
];
